/*
  bb-utility.js — i messaggi della striscia in cima passano uno alla volta.

  PERCHE'
  Tre messaggi affiancati sono tre cose che si guardano a meta'. Uno alla volta
  si legge davvero, e da telefono ci stanno tutti (prima ne restava uno solo,
  gli altri erano nascosti dal CSS e nessuno li leggeva mai).

  COME
  Un solo elemento visibile per volta, gli altri restano nel DOM e sono nascosti
  ai lettori di schermo. Il cambio e' un dissolvenza breve con un filo di
  movimento verticale, e sotto corre una riga sottile che dice quanto manca.

  QUANDO NON GIRA
  - una voce sola: niente rotazione, niente riga
  - col mouse sopra o con il fuoco da tastiera dentro: si ferma, cosi' si fa in
    tempo a leggere e a cliccare un link
  - scheda del browser in secondo piano: si ferma, se no al ritorno si trova un
    messaggio a caso e la riga tutta sballata
  - "riduci le animazioni" attivo: cambia lo stesso ma senza transizioni
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-bb-util]');
  if (!root) return;

  var voci = Array.prototype.slice.call(root.querySelectorAll('[data-bb-util-item]'));
  var pip = Array.prototype.slice.call(root.querySelectorAll('.bb-util__pip'));
  // La riga del tempo e' stata tolta il 7 set 2026: correva verde da sinistra a
  // destra e sembrava una barra di caricamento. Il dinamismo lo da' il cambio
  // del messaggio, non un indicatore che il cliente non ha chiesto.
  var bar = null;

  // L'altezza della striscia serve all'header per sapere dove appiccicarsi.
  function misura() {
    document.documentElement.style.setProperty('--bb-util-h', root.offsetHeight + 'px');
  }
  misura();
  if (window.ResizeObserver) new ResizeObserver(misura).observe(root);
  else window.addEventListener('resize', misura);

  if (voci.length < 2) {
    if (bar) bar.hidden = true;
    return;
  }

  var secondi = parseFloat(root.getAttribute('data-bb-interval')) || 5;
  var durata = Math.max(3, secondi) * 1000;
  var pochiMovimenti = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var i = 0;
  var t = null;
  var fermo = false;

  function mostra(n) {
    voci[i].classList.remove('is-on');
    voci[i].setAttribute('aria-hidden', 'true');
    if (pip[i]) pip[i].classList.remove('is-on');
    i = (n + voci.length) % voci.length;
    voci[i].classList.add('is-on');
    voci[i].removeAttribute('aria-hidden');
    if (pip[i]) pip[i].classList.add('is-on');
  }

  function riavviaBarra() {
    if (!bar || pochiMovimenti) return;
    bar.style.transition = 'none';
    bar.style.transform = 'scaleX(0)';
    // due frame: uno per applicare lo zero, uno perche' la transizione riparta
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        bar.style.transition = 'transform ' + durata + 'ms linear';
        bar.style.transform = 'scaleX(1)';
      });
    });
  }

  function giro() {
    clearTimeout(t);
    if (fermo) return;
    riavviaBarra();
    t = setTimeout(function () {
      mostra(i + 1);
      giro();
    }, durata);
  }

  function ferma(si) {
    fermo = !!si;
    if (fermo) {
      clearTimeout(t);
      if (bar && !pochiMovimenti) {
        // congela la riga dov'e', invece di farla saltare a zero
        var largo = bar.getBoundingClientRect().width;
        var tot = bar.parentNode ? bar.parentNode.getBoundingClientRect().width : 0;
        bar.style.transition = 'none';
        bar.style.transform = 'scaleX(' + (tot ? largo / tot : 0) + ')';
      }
    } else {
      giro();
    }
  }

  root.addEventListener('mouseenter', function () { ferma(true); });
  root.addEventListener('mouseleave', function () { ferma(false); });
  root.addEventListener('focusin', function () { ferma(true); });
  root.addEventListener('focusout', function () { ferma(false); });
  document.addEventListener('visibilitychange', function () { ferma(document.hidden); });

  giro();
})();
